module.exports = __webpack_public_path__ + "static/media/infoicon.3a524683.svg";